import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import { convertiData, monFetch, convertiDataHM } from "../../inc/inc";
import Cookies from "js-cookie";
import DeleteIcon from "@mui/icons-material/Delete";
import { useState, useEffect } from "react";

import PopupElimina from "../../elementi/PopupElimina";
import Popup from "../../elementi/Popup";

const Comp = (props) => {
  const [questionari, setQuestionari] = useState([]);

  const [popupElimina, setPopupElimina] = useState(false);
  const [daEliminare, setDaEliminare] = useState(null);

  const [popupConferma, setPopupConferma] = useState(false);
  const [daConfermare, setDaConfermare] = useState(null);

  const [viewPdfCli, setViewPdfCli] = useState(false);
  const [viewPdfAud, setViewPdfAud] = useState(false);
  const [viewPdfCom, setViewPdfCom] = useState(false);

  const [token, setToken] = useState("");

  async function query() {
    const res = await monFetch("/surveyList", {});
    setQuestionari(res.survey);
  }
  async function getPermessiVisibilitaQuestionari() {
    const res = await monFetch("/userGet", {
      id: Cookies.get("id"),
    });

    if (res.success) {
      setViewPdfCli(res.user.view_pdf_cli ? true : false);
      setViewPdfAud(res.user.view_pdf_aud ? true : false);
      setViewPdfCom(res.user.view_pdf_com ? true : false);
      setToken(res.user.token);
    }
  }

  async function elimina(id) {
    const res = await monFetch("/surveyDelete", { id });
    setPopupElimina(false);
    query();
  }

  async function settaCompletato(e, id) {
    e.stopPropagation();
    const res = await monFetch("/surveySetCompleted", { id });
    query();
  }

  useEffect(() => {
    props.setTestoTitolo(
      <>
        <Button
          variant="contained"
          href={process.env.PUBLIC_URL + "/questionario-nuovo"}
          className="buttonSalva"
          style={{ marginRight: 20 }}
        >
          Nuovo{" "}
        </Button>
        Questionari
      </>
    );
    query();
    getPermessiVisibilitaQuestionari();

    console.log("HOME QUESTIONARI");
  }, []);

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Cliente</TableCell>
            <TableCell>Data</TableCell>
            <TableCell>Versione</TableCell>
            <TableCell>Cod. versione</TableCell>
            <TableCell>Review</TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {questionari.map((c) => {
            return (
              <TableRow
                key={c.id}
                className="rigaSelezionabile"
                onClick={(e) => {
                  window.location.href =
                    process.env.PUBLIC_URL + "/questionario/" + c.id;
                }}
              >
                <TableCell>{c.businessName}</TableCell>
                <TableCell>{convertiData(c.date)}</TableCell>
                <TableCell>{convertiDataHM(c.version * 1000)}</TableCell>
                <TableCell>{c.version}</TableCell>
                <TableCell>{c.review}</TableCell>
                <TableCell>
                  {c.answerCount > 0 && !c.completed && (
                    //non completo
                    <Button
                      className="buttonSalva"
                      variant="contained"
                      href={process.env.PUBLIC_URL + "/questionario/domanda"}
                      style={{ marginRight: 8 }}
                      onClick={(e) => {
                        Cookies.set("idQuestionario", c.id);
                      }}
                    >
                      Continua
                    </Button>
                  )}
                  {!c.answerCount && !c.completed && (
                    //da iniziare
                    <Button
                      className="buttonSalva"
                      style={{ marginRight: 8 }}
                      variant="contained"
                      href={process.env.PUBLIC_URL + "/questionario/domanda"}
                      onClick={(e) => {
                        Cookies.set("idQuestionario", c.id);
                      }}
                    >
                      Inizia
                    </Button>
                  )}
                  {!c.completed && (
                    //da iniziare
                    <Button
                      className="buttonSuccess"
                      style={{ marginRight: 8 }}
                      variant="contained"
                      onClick={(e) => {
                        e.stopPropagation();
                        setDaConfermare(c.id);
                        setPopupConferma(true);
                      }}
                    >
                      Setta Completo
                    </Button>
                  )}
                  {c.completed == 1 && (
                    //completo
                    <b style={{ marginRight: 8 }}>Completato</b>
                  )}
                  {viewPdfCli && (
                    <Button
                      className="buttonSalva"
                      style={{ marginRight: 8 }}
                      variant="contained"
                      href={
                        process.env.REACT_APP_BACKEND +
                        "/pdf/cli/" +
                        c.id +
                        "/" +
                        token +
                        "/" +
                        c.fileName +
                        "_cliente"
                      }
                      target="_blank"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      PDF Cliente
                    </Button>
                  )}
                  {viewPdfAud && (
                    <Button
                      title="intestazione + riepilogo + domande + spiegazione + risposte"
                      className="buttonSalva"
                      style={{ marginRight: 8 }}
                      variant="contained"
                      href={
                        process.env.REACT_APP_BACKEND +
                        "/pdf/aud/" +
                        c.id +
                        "/" +
                        token +
                        "/" +
                        c.fileName +
                        "_auditor"
                      }
                      target="_blank"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      Relazione completa
                    </Button>
                  )}
                  {viewPdfCom && (
                    <Button
                      title="intestazione + note commerciali domande + note commerciali risposte"
                      className="buttonSalva"
                      variant="contained"
                      href={
                        process.env.REACT_APP_BACKEND +
                        "/pdf/com/" +
                        c.id +
                        "/" +
                        token +
                        "/" +
                        c.fileName +
                        "_commerciale"
                      }
                      target="_blank"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      Relazione Commerciale
                    </Button>
                  )}
                </TableCell>
                <TableCell>
                  {c.completed != 1 && (
                    <DeleteIcon
                      color="error"
                      style={{
                        cursor: "pointer",
                        opacity: 1,
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setPopupElimina(true);
                        setDaEliminare(c.id);
                      }}
                    />
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <PopupElimina
        open={popupElimina}
        fnAnnulla={(e) => setPopupElimina(false)}
        fnSuccess={(e) => elimina(daEliminare)}
      />

      <Popup
        open={popupConferma}
        titolo={"Conferma completamento"}
        testo={"Confermi che il questionario è completo?"}
        fnAnnulla={(e) => setPopupConferma(false)}
        fnSuccess={(e) => {
          settaCompletato(e, daConfermare);
          setPopupConferma(false);
        }}
      />
    </>
  );
};

export default Comp;
